import * as React from "react";
const SvgZai = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "currentColor", fillRule: "evenodd", height: "1em", style: {
  flex: "none",
  lineHeight: 1
}, viewBox: "0 0 24 24", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("title", null, "Z.ai"), /* @__PURE__ */ React.createElement("path", { d: "M12.105 2L9.927 4.953H.653L2.83 2h9.276zM23.254 19.048L21.078 22h-9.242l2.174-2.952h9.244zM24 2L9.264 22H0L14.736 2H24z" }));
export default SvgZai;
